import { IconShoppingCartCheck } from '@tabler/icons-react';

import { TimeSeriesChart } from '@charts';

export default function SalesAmountChart({ report, reportLoading }) {
    return (
        <TimeSeriesChart
            title="Vendas no período"
            icon={<IconShoppingCartCheck size={15} />}
            timeSeries={report?.salesAmount}
            valueType="number"
            unitSingular="venda"
            unitPlural="vendas"
            report={report}
            reportLoading={reportLoading}
        />
    );
}
